(function () {
  const selector = '.jdgm-prev-badge__text';

  function clean(el) {
    if (!el || el.nodeType !== 1) return;

    const txt = (el.textContent || '').trim();
    const num = (txt.match(/\d+/) || [''])[0];

    if (num && txt !== num) el.textContent = num;
  }

  function cleanAll(root = document) {
    root.querySelectorAll(selector).forEach(clean);
  }


  cleanAll();


  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {

      if (m.type === 'characterData') {
        const parent = m.target && m.target.parentElement;
        if (parent && parent.matches && parent.matches(selector)) clean(parent);
        continue;
      }

   
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;

   
          if (node.matches && node.matches(selector)) clean(node);

       
          if (node.querySelectorAll) cleanAll(node);
        });
      }
    }
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });


  setTimeout(cleanAll, 1000);
})();